import { apiClient } from './client';
import type { ApiResponse } from '../types/api';
import type { DashboardData, PerformanceReport } from '../types/dashboard';

export const dashboardApi = {
  getDashboard: (): Promise<ApiResponse<DashboardData>> =>
    apiClient.get('/dashboard'),

  // 获取周报
  // year: 年份（可选，默认当前年）
  // week: 周数（可选，默认当前周，1-53）
  // refresh: 是否强制重新生成（可选）
  getWeeklyReport: (params?: { year?: number; week?: number; refresh?: boolean }): Promise<ApiResponse<PerformanceReport>> =>
    apiClient.get('/reports/weekly', { params }),

  // 获取月报
  // year: 年份（可选，默认当前年）
  // month: 月份（可选，默认当前月，1-12）
  // refresh: 是否强制重新生成（可选）
  getMonthlyReport: (params?: { year?: number; month?: number; refresh?: boolean }): Promise<ApiResponse<PerformanceReport>> =>
    apiClient.get('/reports/monthly', { params }),

  // 获取年报
  // year: 年份（可选，默认当前年）
  // refresh: 是否强制重新生成（可选）
  getYearlyReport: (params?: { year?: number; refresh?: boolean }): Promise<ApiResponse<PerformanceReport>> =>
    apiClient.get('/reports/yearly', { params }),

  getCustomReport: (params: { start_date: string; end_date: string }): Promise<ApiResponse<PerformanceReport>> =>
    apiClient.get('/reports/custom', { params }),
};
